import axios from "axios";
import { getURLParamters, flushLocalStorage } from "../shared/helpers";

//Base URL end point
//Base URL end point
// const RIO = "http://alertauto.trackwayz.com/api/";
const UATPROD = "http://uat-uw.palminsure.com/api/";
//  const LOCALHOST = "http://localhost:8083/api/";
// const SWAGGER = "http://192.168.50.120:8887/api/";
// const FORMSUATPROD = "http://piformsuat.trackwayz.com/api/";
// const INFLIGHT = "http://forms-titan.trackwayz.com/api/";
// const INFLIGHTSWAGGER = "http://192.168.50.120:8083/api/";
// const HOST = "http://172.20.81.236:8083/api/";
const UWPORTAL = "https://uw.palminsure.com/api/";

// const PIUAT = "http://piuat.trackwayz.com/api/";
// const claims = "http://pi-claim-uat.trackwayz.com/api/";
const claims = "http://uat-uw.palminsure.com/api/";

export const baseUrlLogin = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? UATPROD : UWPORTAL,
});

export const baseUrl = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? UATPROD : UWPORTAL,
  headers: {
    "Content-Type": "application/json",
  },
});

//Request
baseUrl.interceptors.request.use(
  function (config) {
    config.headers["Authorization"] = localStorage.getItem("AUTH_TOKEN");
    return config;
  },
  function (err) {
    return Promise.reject(err);
  },
);

// Response
baseUrl.interceptors.response.use(
  function (response) {
    // let resStatus =
    //   response && response.data.statusCode ? response.data.statusCode : 0;
    if (response && response.data.statusCode === 200) {
    } else {
      const urlParms = getURLParamters();
      if (
        response &&
        response.data.statusCode === 404 &&
        response.data.message === `Policy ${urlParms} does not exist `
      ) {
        flushLocalStorage(urlParms);
      } else if (response.status !== 200) {
      }
    }
    return response;
  },
  function (error) {
    if (error && error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    // if (error.response && error.response.data.message) {
    //   return Promise.reject(error.response.data);
    // }
    // return Promise.reject(error);
    return error;
  },
);

export default baseUrl;
